import React from "react";
import classNames from "classnames";
import InfiniteProgress from "../_common/InfiniteProgress";
import { authSelectors } from "../../redux/app/auth";
import { IStore } from "../../redux/store";
import { connect } from "react-redux";
import { IAuth_Get_Jobs } from "../../redux/app/auth/types";
import { Redirect } from "react-router-dom";
import { rootRoutes } from "../../routes";
// import WSLogo from "./../../assets/logos/logo-with-text.svg";
type AuthType = React.PropsWithChildren<
	IAuth_Get_Jobs & { authToken: string | null }
>;
const Auth: React.FC<AuthType> = (props: AuthType) => {
	if (props.authToken !== null)
		return (
			<Redirect
				to={{
					pathname: rootRoutes.children.app.children.vessel.path,
				}}
			/>
		);
	const { children, loginJob, resetPasswordJob, resetRequestJob } = props;
	return (
		<>
			<div
				className={classNames(
					"flex flex-row justify-center items-center", // Layout [Flex, Inline, Grid]
					"h-full", // Sizing [Width, Height]
					"", // Spacing [Padding, Margin]
					"", // Font [Font Size, Font style]
					"bg-transparent", // Colors [Border, Background, Font Colors]
					"", // Borders [Border size, style, width, radius]
					"overflow-hidden z-10" // Position [Absolute, Relative]
				)}
			>
				<div className="flex-row items-stretch w-full min-h-full xl:w-1/3 lg:w-1/3 md:w-1/2 sm:w-3/4">
					<div
						className={classNames(
							"", // Layout [Flex, Inline, Grid]
							"sm:min-h-full", // Sizing [Width, Height]
							"my-0 mx-0 sm:mx-6 sm:my-64", // Spacing [Padding, Margin]
							"", // Font [Font Size, Font style]
							"bg-white", // Colors [Border, Background, Font Colors]
							"sm:rounded-lg border", // Borders [Border size, style, width, radius]
							"" // Position [Absolute, Relative]
						)}
					>
						<div className="px-6 pt-8 pb-6 bg-white rounded-t-lg border-b border-gray-100">
							{/* <img src={WSLogo} className="mx-auto my-3" /> */}
							<h1
								className={classNames(
									"font-redhat-text text-3xl font-semibold tracking-tight text-center",
									"text-gray-900"
								)}
							>
								E-Logs Portal
							</h1>
							<p className="mt-2 text-sm text-center text-gray-500">
								Sign in to continue to your account
							</p>
						</div>
						<div>
							<InfiniteProgress
								isLoading={
									loginJob.isLoading ||
									resetPasswordJob.isLoading ||
									resetRequestJob.isLoading
								}
								isSpacedOut={false}
								isSticky={true}
							/>
						</div>
						<div className="p-6 px-6 sm:px-12">{children}</div>
					</div>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (store: IStore) => ({
	...authSelectors(store.app.auth).getAllJobs(),
	authToken: store.app.auth.authToken,
});

export default connect(mapStateToProps, () => ({}))(Auth);
